import { ETypeChamp } from '../../../z16pro/classes/typeChamp';
import { ViewContainerRef, ComponentFactoryResolver, Input, ViewChild, AfterViewInit, Component, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { TypeChamp } from '../../../z16pro/classes/typeChamp';

@Component({
    selector: 'app-dynamic-input',
    templateUrl: './dynamic-input.component.html',
    styleUrls: ['./dynamic-input.component.css']
})
export class DynamicInputComponent {

    @Input() type: TypeChamp; // InputType
    @Input() data: any;
    @Input() resource: string;
    @Input() resourceId: string;

    @Output() valueChanged: EventEmitter<boolean | string> = new EventEmitter();

    @ViewChild('container', {read: ViewContainerRef}) container;

    componentRef: any;

    constructor(
        public viewContainerRef: ViewContainerRef,
        private componentFactoryResolver: ComponentFactoryResolver
    ) { 
    }

    /*ngOnChanges(changes: SimpleChanges) {
        if (changes.data == null) {
            return;
        }

        if (this.shouldUpdate(changes.data.previousValue, changes.data.currentValue)) {
            this.initializeComponent(changes.data.currentValue);
        }
    }*/

    /*ngAfterViewInit() {
        this.initializeComponent(this.data);
    }*/

    /*shouldUpdate(prevValue, newValue) {
        let shouldUpdate = false;

        if (prevValue === undefined) {
            return true;
        }

        for (const k in prevValue) {
            if (prevValue.hasOwnProperty(k)) {
                if (shouldUpdate === false) {
                    if (typeof prevValue[k] !== 'object') {
                        shouldUpdate = prevValue[k] !== newValue[k];
                    }
                }
            }
        }

        return shouldUpdate;
    }*/

    /*initializeComponent(data: any) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.component);
        this.container.clear();

        this.componentRef = this.container.createComponent(componentFactory);

        this.injectProps(data);
    }*/

    /*injectProps(data: any) {
        if (!this.componentRef) {
            return;
        }

        Object.keys(data).map(key => {
            this.componentRef.instance[key] = data[key];
        });

        this.componentRef.instance.valueChanged
            .subscribe(value => {
                this.valueChanged.emit(value);
            });
    }*/

    get isTextInput(): boolean {
        return this.type.code === ETypeChamp.TEXT;
    }

    get isSpacer(): boolean {
        return this.type.code === ETypeChamp.SPACER;
    }

    get isSelect(): boolean {
        return this.type.code === ETypeChamp.SELECT;
    }

    get isSelectCouleur(): boolean {
        return this.type.code === ETypeChamp.SELECTCOULEUR;
    }

    get isMutliSelect(): boolean {
        return this.type.code === ETypeChamp.MULTISELECT;
    }

    get isCheckbox(): boolean {
        return this.type.code === ETypeChamp.CHECKBOX;
    }

    get isTextarea(): boolean {
        return this.type.code === ETypeChamp.TEXTAREA;
    }

    get isRadio(): boolean {
        return this.type.code === ETypeChamp.RADIO;
    }

    get isFileInput(): boolean {
        return this.type.code === ETypeChamp.FILE;
    }

    get isDateInput(): boolean {
        return this.type.code === ETypeChamp.DATE;
    }

    get isPriceInput(): boolean {
        return this.type.code === ETypeChamp.PRIX;
    }

    get isLegendInput(): boolean {
        return this.type.code === ETypeChamp.SECTION;
    }
    
    get isTableau(): boolean {
        return this.type.code === ETypeChamp.TABLEAU;
    }


}
